import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordNavPath } from '@/utils/navHistory';

/** 路由变化时回到页顶，避免从结果页中下部点「查看详情」仍停在底部 */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // 记录导航轨迹：分析页「返回」按钮要按来路给准确文案与落点
    recordNavPath(pathname, search);
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, search]);

  return null;
}
